import { useEffect, useState } from 'react'
import { Box } from '@mui/system'
import { Alert, Stack, Typography } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import OfoqPasswordField from '../../components/Forms/OfoqPasswordField.jsx'
import OfoqThemeBtn from '../../components/Buttons/OfoqThemeBtn.jsx'
import { userAuthChangePassword } from '../../redux/features/userAuth/userAuthThunk'
import { selectAuthUser } from '../../redux/features/userAuth/userAuthSlice'
import { isNotEmpty } from '../../utils/helpers'
import UseTranslation from '../../hooks/UseTranslation.jsx'

const Form = ({ setChangePasswordSuccess }) => {
  const dispatch = useDispatch()
  const userAuth = useSelector(selectAuthUser)
  const { t } = UseTranslation()
  const [password, setPassword] = useState(null)
  const [newPassword, setNewPassword] = useState(null)
  const [repeatPassword, setRepeatPassword] = useState(null)
  const [errorMessage, setErrorMessage] = useState(null)
  const [validPassword, setValidPassword] = useState(false)
  const [isFormNotValid, setIsFormNotValid] = useState(true)

  useEffect(() => {
    if (isNotEmpty(userAuth.alert?.status)) {
      setErrorMessage(userAuth.alert)
    } else {
      setErrorMessage(null)
    }
  }, [userAuth])

  const isMatch = isNotEmpty(newPassword) && isNotEmpty(repeatPassword) &&
  newPassword === repeatPassword;

  useEffect(() => {
    setIsFormNotValid(validPassword && isMatch && isNotEmpty(password))
  }, [password, newPassword, repeatPassword, validPassword])

  const submitHandler = async () => {
    dispatch(
      userAuthChangePassword({
        queries: {
          old_password: password,
          new_password: newPassword,
        },
      }),
    ).then((res) => {
      if (res?.meta?.requestStatus === 'fulfilled') {
        setChangePasswordSuccess(true)
      }
    })
  }

  return (
        <Box sx={styles.leftSideContainer}>
          <Typography variant={'h4'} sx={styles.formTitle}>
             {t?.['Set your Password']}
          </Typography>

          <Typography component={'p'} sx={styles.formSubTitle}>{t?.['Please add the new password you need to set for your account']}</Typography>

          {isNotEmpty(errorMessage?.status) && (
            <Stack sx={styles.errorContainer} spacing={2}>
              <Alert variant='filled' severity={errorMessage.severity}>
                {errorMessage.message}
              </Alert>
            </Stack>
          )}

          <form style={styles.formContainer}>
            <OfoqPasswordField
              defaultValue={password}
              refState={setPassword}
              placeholder={t?.['Enter the Password that was Sent to your Mail']}
              name={t?.['old password']}
              hideInputValidator
              required
            />

            <OfoqPasswordField
              defaultValue={newPassword}
              refState={setNewPassword}
              placeholder={t?.['Enter the new password']}
              name={t?.['new password']}
              setValidPassword={setValidPassword}
              hideInputValidator={false}
              required
            />

            <OfoqPasswordField
              defaultValue={repeatPassword}
              refState={setRepeatPassword}
              placeholder={t?.['Repeat the New Password']}
              name={t?.['Repeat New Password']}
              hideInputValidator
              passwordMatch={isMatch }
              required
            />

            <Box sx={styles.formBtns}>
              <OfoqThemeBtn customStyle={styles.continueBtn}
                 name={t?.save}
                 onClick={(e) => submitHandler(e)}
                 disabled={!isFormNotValid}
              />
            </Box>
          </form>
        </Box>

  )
}
const styles = {

  leftSideContainer: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: { xs: '100%', sm: '300px', md: '550px' },
    marginTop: { xs: '30px', sm: '0px' },
    mx: { xs: '0px', sm: '40px' },
    px: '10px',
    zIndex: '2',
  },

  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: { xs: '100%', sm: '400px' },
  },

  formTitle: {
    color: 'primary.contrastText',
    fontSize: { xs: '24px', md: '28px' },
    mb: { xs: '10px', sm: '10px' },
  },
  formSubTitle: {
    fontSize: { xs: '14px', sm: '16px' },

    mb: { xs: '20px', sm: '30px' },
  },
  formBtns: {
    display: 'flex',
    minWidth: '100%',
    justifyContent: { xs: 'center', sm: 'flex-end' },
    marginTop: { xs: '10px', sm: '30px' },
  },
  continueBtn: {
    maxWidth: { xs: '100%', sm: '189px' },
    height: '40px',
  },

  errorContainer: {
    width: '100%',
    marginBottom: '30px',
  },
}

export default Form
